import React from 'react'

import constants from './../constants'
import ClientContext from 'contexts/ClientContext'
import useBeforeunload from 'hooks/useBeforeunload'

const defaultClient = {
  name: '',
  createPasswordByEmail: true,
  email: '',
  companyName: '',
  tradeName: '',
  kind: constants.people.PERSON,
  cpf: '',
  cnpj: '',
  phone: '',
  code: '',
  addressAttributes: {
    street: '',
    number: '',
    neighborhood: '',
    complement: '',
    postalCode: '',
    city: '',
    state: '',
  },
}

const ClientProvider = ({ children }) => {
  const [activeStep, setActiveStep] = React.useState(0)
  const [data, setData] = React.useState(defaultClient)
  const [formId, setFormId] = React.useState(null)

  useBeforeunload(() => {
    return 'Sair do site?'
  })

  const handleChange = e => {
    setData({ ...data, [e.target.name]: e.target.value })
  }

  const nextStep = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const backStep = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  const handleReset = () => {
    setData(defaultClient)
    setActiveStep(0)
  }

  return (
    <ClientContext.Provider
      value={{
        data,
        formId,
        activeStep,
        setData,
        setActiveStep,
        setFormId,

        backStep,
        nextStep,

        handleChange,
        handleReset,
      }}
    >
      {children}
    </ClientContext.Provider>
  )
}

export default ClientProvider
